import React from 'react';

const Forbidden = () => (
  <h1>Forbidden</h1>
);

export default Forbidden;
